<template>
  <div class="col-md-12">
    <br />
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Type:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name="Type" v-model="encodingData.Type" class="form-control">
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.realEstateType"
              v-bind:key="option.realEstateType"
            >
              {{ option.realEstateType }}
            </option>
          </select>
        </div>
      </div>
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >RegisterNo :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'max:50'"
            name="RegisterNo"
            v-model="encodingData.RegisterNo"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('RegisterNo') }" />
                    <div v-if="submitted && errors.has('RegisterNo')"
                         class="invalid-feedback">
                        {{ errors.first("RegisterNo") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="Country"
            v-model="encodingData.Country"
            class="form-control"
          >
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >State:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="State"
            v-model="encodingData.State"
            class="form-control"
          >
            <option value>Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >City :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
           name="City"
           v-validate="'max:50'" 
           v-model="encodingData.City" 
           class="form-control"
           :class="{ 'is-invalid': submitted && errors.has('City') }" />
                    <div v-if="submitted && errors.has('City')"
                         class="invalid-feedback">
                        {{ errors.first("City") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Address :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Address"
            v-validate="'max:200'" 
            v-model="encodingData.Address"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('Address') }" />
                    <div v-if="submitted && errors.has('Address')"
                         class="invalid-feedback">
                        {{ errors.first("Address") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Location :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Location"
            v-validate="'max:50'" 
            v-model="encodingData.Location"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('Location') }" />
                    <div v-if="submitted && errors.has('Location')"
                         class="invalid-feedback">
                        {{ errors.first("Location") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >PostalCode :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="PostalCode"
            v-validate="'max:50'" 
            v-model="encodingData.PostalCode"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('PostalCode') }" />
                    <div v-if="submitted && errors.has('PostalCode')"
                         class="invalid-feedback">
                        {{ errors.first("PostalCode") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopRE" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  checkLinkMode,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageRealEstateType,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Type: "",
        RegisterNo: "",
        Country: "",
        State: "",
        City: "",
        Address: "",
        Location: "",
        PostalCode: "",
        Comments: "",
      },
      countries: [],
      provinces: [],
      types: [],
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      let loader = this.$loading.show();
      instance
        .post(EncodeURL + "newRealEstate", this.encodingData, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error) {
            loader.hide();
            notifyHelper(
              "error",
              "There was an error processing your request!"
            );
          } else {
            loader.hide();
            notifyHelper("success", "Saved");
            //this.clearControls()
            if (checkLinkMode()) {
              if (confirm("Link this newly created entity?")) {
                setObject2Link(response.data.id, "RE");
                this.setLink(response.data.id);
              }
            }
          }
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstorageRealEstateType();
    },
    setLink: function (id) {
      setObject2Link(id, "RE");
      this.$bvModal.show("LinkPopRE");
    },
    clearControls() {
      this.encodingData.Type = "";
      this.encodingData.RegisterNo = "";
      this.encodingData.Country = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
      this.encodingData.Address = "";
      this.encodingData.Location = "";
      this.encodingData.PostalCode = "";
      this.encodingData.Comments = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>
